import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Icon } from '@fnacdarty/back-office-ui';
import { updateActivityStatus } from '../../utils/activity';

import {
	StyledActivityItem,
	StyledActionContainer,
	StyledInformationContainer,
	StyledBlock,
	StyledBlockCenter,
	StyledRow,
	StyledRowCenter,
	StyledItem,
	StyledBoldItem,
	StyledHeader,
	StyledBottomBar,
} from './index.styled';
import { formatWeek, formatDateFR } from '../../../../utils/date';
import { getUser } from '../../../authentication/utils/auth';

const ActivityItem = ({
	activity,
	updateActivity,
	selectedActivity,
	setSelectedActivity,
	isVersionPC,
	refActivityId,
}) => {
	// destructuring activity object
	const {
		customer,
		date,
		activityType,
		project,
		resource,
		week,
		readStatus,
		processStatus,
	} = activity;

	const ref = useRef();

	const isUserExterne = () => {
		if (getUser().roles.includes('ROLE_CUISINE_EXTERNE')) {
			return true;
		}
		return false;
	};

	// handle checkbox of the current activity
	const onCheckBoxClick = () => {
		const updatedActivity = {
			...activity,
			processStatus: !processStatus,
		};
		if (!readStatus && isUserExterne()) {
			updatedActivity.readStatus = true;
		}
		updateActivity(updatedActivity);

		updateActivityStatus(updatedActivity);
	};

	// handle line click of the current activity
	const handleItemSelection = () => {
		if (isVersionPC()) {
			setSelectedActivity(activity);
		}
		if (!readStatus && isUserExterne()) {
			const updatedActivity = {
				...activity,
				readStatus: true,
			};

			updateActivity(updatedActivity);

			updateActivityStatus(updatedActivity);
		}
	};
	const handleItemSelectionVersionMobile = () => {
		if (!isVersionPC()) {
			setSelectedActivity(activity);

			if (!readStatus && isUserExterne()) {
				const updatedActivity = {
					...activity,
					readStatus: true,
				};

				updateActivity(updatedActivity);

				updateActivityStatus(updatedActivity);
			}
		}
	};

	const formatedDate = formatDateFR(new Date(date));

	const formatedWeek = formatWeek(new Date(week));
	useEffect(() => {
		const { id } = activity;
		if (id === refActivityId) {
			ref.current?.scrollIntoView({ behavior: 'smooth' });
			let firstSowhDetail = true;
			if (!isVersionPC()) {
				firstSowhDetail = false;
			}
			setSelectedActivity(activity, firstSowhDetail);
		}
	}, []);

	return (
		<>
			<StyledActivityItem
				$selected={selectedActivity?.id === activity.id}
				onClick={handleItemSelection}
				ref={ref}
				key={activity.nuint}
				$readStatus={readStatus}
			>
				<StyledBlock>
					<StyledActionContainer>
						<Checkbox
							checked={processStatus}
							onChange={onCheckBoxClick}
						/>
					</StyledActionContainer>
					<StyledInformationContainer
						onClick={handleItemSelectionVersionMobile}
					>
						<StyledRow style={{ width: '380px' }}>
							<StyledHeader>
								{customer?.civility} {customer?.firstname}{' '}
								{customer?.name}
							</StyledHeader>
							<StyledBoldItem>{formatedDate}</StyledBoldItem>
						</StyledRow>

						<StyledRow>
							<StyledBoldItem>{activityType}</StyledBoldItem>
							<StyledItem>Chantier {project}</StyledItem>
						</StyledRow>

						<StyledRow>
							<StyledItem>{resource?.name}</StyledItem>
						</StyledRow>
					</StyledInformationContainer>
				</StyledBlock>

				{isVersionPC() && (
					<>
						<StyledBlock>
							<StyledItem>
								<Icon name="home" width={20} />
							</StyledItem>
							<StyledInformationContainer
								style={{ width: '300px' }}
							>
								<StyledItem>{customer?.address}</StyledItem>
								<StyledItem>
									{customer?.zipCode}&nbsp;
									{customer?.city}
								</StyledItem>
							</StyledInformationContainer>
						</StyledBlock>
						<StyledBlockCenter style={{ width: '320px' }}>
							<StyledRowCenter>
								<StyledItem>Semaine {formatedWeek}</StyledItem>
							</StyledRowCenter>
						</StyledBlockCenter>
					</>
				)}
			</StyledActivityItem>
			<StyledBottomBar />
		</>
	);
};

ActivityItem.propTypes = {
	activity: PropTypes.object,
	updateActivity: PropTypes.func,
	selectedActivity: PropTypes.object,
	isVersionPC: PropTypes.func,
	setSelectedActivity: PropTypes.func,
	refActivityId: PropTypes.string,
};

export default ActivityItem;
